import { getVersionForClone } from '@qr-front/ui/utils'

import { BaseRestaurantLogo } from './BaseRestaurantLogo'
import { Clone1RestaurantLogo } from './Clone1RestaurantLogo'

export const RestaurantLogo = getVersionForClone({
	base: BaseRestaurantLogo,
	clone1: Clone1RestaurantLogo,
})
